export const rawCommandArgsMapper = (command: object) => ({
  command,
})
